import Cookies from 'js-cookie'
import { shallowRef } from 'vue'

// The session token lives in a cookie, which Vue cannot observe, while the store getters that decode it
// are cached computeds. Every read goes through this version ref and every write bumps it, so a sign-out
// followed by a login as someone else in the same tab re-evaluates those getters instead of keeping the
// previous session's user.
const COOKIE = 'auth_token'
const EXPIRES_DAYS = 6 * 31
const version = shallowRef(0)

const touch = () => {
  version.value += 1
}

export const readAuthToken = () => {
  version.value
  return Cookies.get(COOKIE)
}

export const setAuthToken = token => {
  Cookies.set(COOKIE, token, { expires: EXPIRES_DAYS })
  touch()
}

export const clearAuthToken = () => {
  Cookies.remove(COOKIE)
  touch()
}
